export { default as applyFavicon } from './utils/applyFavicon';
export { default as registerFaviconProvider } from './utils/registerFaviconProvider';
